import {
  BaseHeader,
  EmptyHeader,
  SortableHeader,
  SummaryTitleHeader,
  TitleHeader,
} from 'features/dashboard/table/column/DashboardHeaders'
import {
  CampaignCell,
  CampaignTypeCell,
  DateCell,
  IdCell,
  OperationStatusCell,
} from 'features/dashboard/table/column/DashboardCells'
import {
  AdGroupContentMatchingMaxBiddingAmountCell,
  AdGroupDailyBudgetCell,
  AdGroupKeywordExCell,
  AdGroupMaxBiddingAmountCell,
  AdGroupMediaTypeCell,
  AdGroupNameCell,
  AdGroupPeriodCell,
  AdGroupSegmentKeywordCell,
  AdGroupUserDeviceCell,
  AdGroupWeeklyScheduleCell,
} from 'features/dashboard/table/column/adGroup/AdGroupCells'
import {
  metricColumns,
  selectionColumn,
  statusColumn,
} from 'features/dashboard/table/column/DashboardColumns'
import { EtcColumns, GeneralColumns } from '../../../../Columns'

/**
 * 광고그룹 테이블 칼럼
 * https://wiki.daumkakao.com/pages/viewpage.action?pageId=818962892
 */
export const AdGroupFixedColumns = [
  selectionColumn,
  {
    accessor: 'name',
    sticky: 'left',
    Header: TitleHeader,
    columns: [
      {
        accessor: 'name',
        width: 370,
        Header: SummaryTitleHeader,
        Cell: AdGroupNameCell,
      },
    ],
  },
  statusColumn,
]

export const AdGroupConfigurableColumns = [
  {
    accessor: GeneralColumns.operationStatus.name,
    Header: BaseHeader,
    title: GeneralColumns.operationStatus.displayName,
    tooltip: (
      <>
        광고그룹 게재와 관련된 현재 상태를 의미합니다.
        <br />
        상위 캠페인의 상태를 고려하여 현재 광고그룹의 최종 운영 상태를
        표기합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.operationStatus.name,
        width: 180,
        Header: EmptyHeader,
        Cell: OperationStatusCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.campaignType.name,
    Header: SortableHeader,
    title: GeneralColumns.campaignType.displayName,
    tooltip:
      '캠페인 유형을 통하여 원하는 목표를 달성하는데 적합한 캠페인, 광고그룹, 키워드, 소재 설정을 제공합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaignType.name,
        width: 130,
        Header: EmptyHeader,
        Cell: CampaignTypeCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.maxBiddingAmount.name,
    Header: SortableHeader,
    title: GeneralColumns.maxBiddingAmount.displayName,
    tooltip: '광고그룹에 설정된 기본 입찰금액 입니다.',
    columns: [
      {
        accessor: GeneralColumns.maxBiddingAmount.name,
        width: 120,
        Header: EmptyHeader,
        Cell: AdGroupMaxBiddingAmountCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.dailyBudget.name,
    Header: SortableHeader,
    title: GeneralColumns.dailyBudget.displayName,
    tooltip: '광고그룹에 설정된 일예산을 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.dailyBudget.name,
        width: 100,
        Header: EmptyHeader,
        Cell: AdGroupDailyBudgetCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.impressionDate.name,
    Header: SortableHeader,
    title: GeneralColumns.impressionDate.displayName,
    tooltip: (
      <>
        광고그룹(삭제 제외)의 가장 빠른 시작일부터
        <br />
        가장 늦은 종료일을 의미합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.impressionDate.name,
        width: 180,
        Header: EmptyHeader,
        Cell: AdGroupPeriodCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.impressionWeeklySchedule.name,
    Header: SortableHeader,
    title: GeneralColumns.impressionWeeklySchedule.displayName,
    tooltip: '특정 기간에 광고를 노출중인지를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.impressionWeeklySchedule.name,
        width: 130,
        Header: EmptyHeader,
        Cell: AdGroupWeeklyScheduleCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.contentMatchingmaxBiddingAmount.name,
    Header: SortableHeader,
    title: GeneralColumns.contentMatchingmaxBiddingAmount.displayName,
    tooltip: '광고그룹에 설정된 콘텐츠 매체 입찰금액 입니다.',
    columns: [
      {
        accessor: GeneralColumns.contentMatchingmaxBiddingAmount.name,
        width: 160,
        Header: EmptyHeader,
        Cell: AdGroupContentMatchingMaxBiddingAmountCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.mediaType.name,
    Header: SortableHeader,
    title: GeneralColumns.mediaType.displayName,
    tooltip: '광고가 노출되는 매체유형을 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.mediaType.name,
        width: 120,
        Header: EmptyHeader,
        Cell: AdGroupMediaTypeCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.userDevice.name,
    Header: SortableHeader,
    title: GeneralColumns.userDevice.displayName,
    tooltip: '광고가 노출되는 디바이스를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.userDevice.name,
        width: 110,
        Header: EmptyHeader,
        Cell: AdGroupUserDeviceCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.segmentKeyword.name,
    Header: SortableHeader,
    title: GeneralColumns.segmentKeyword.displayName,
    tooltip: '분절 키워드 설정여부를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.segmentKeyword.name,
        width: 130,
        Header: EmptyHeader,
        Cell: AdGroupSegmentKeywordCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.keywordEx.name,
    Header: SortableHeader,
    title: GeneralColumns.keywordEx.displayName,
    tooltip: '키워드확장 설정여부를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.keywordEx.name,
        width: 130,
        Header: EmptyHeader,
        Cell: AdGroupKeywordExCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.campaign.name,
    Header: BaseHeader,
    title: GeneralColumns.campaign.displayName,
    tooltip: '광고그룹이 소속된 캠페인을 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaign.name,
        width: 330,
        Header: EmptyHeader,
        Cell: CampaignCell,
      },
    ],
  },
  {
    accessor: EtcColumns.adGroupId.name,
    Header: SortableHeader,
    title: EtcColumns.adGroupId.displayName,
    tooltip: '광고그룹 마다 부여된 고유의 식별값을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.adGroupId.name,
        width: 160,
        Header: EmptyHeader,
        Cell: IdCell,
      },
    ],
  },
  {
    accessor: EtcColumns.createdDate.name,
    Header: SortableHeader,
    title: EtcColumns.createdDate.displayName,
    tooltip: '광고그룹이 최초 등록된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.createdDate.name,
        width: 130,
        Header: EmptyHeader,
        Cell: DateCell,
      },
    ],
  },
  {
    accessor: EtcColumns.updatedDate.name,
    Header: SortableHeader,
    title: EtcColumns.updatedDate.displayName,
    tooltip: '광고그룹이 최종 수정된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.updatedDate.name,
        width: 130,
        Header: EmptyHeader,
        Cell: DateCell,
      },
    ],
  },
  ...metricColumns,
]
